/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-16 09:25:02
 */ 
export const ConsultationOrderEn = {
    xunjiadang:'Purchase record',
    fanhui:'Back',
    quanbu:'All orders',
    daizhifu:'To be paid',
    daishenghe:'To audit',
    yizhifu:'Paid',
    yiwangcheng:'Completed',
    yipingjia:'Already evaluated',
    yizuiping:'Reviewed',
    zuanjiaxinxi:'Expert information',
    jiage:'Price',
    zixunjindu:'Order status',
    caozuo:'operation',
    qingshuru:'Please enter the order number keyword / expert name',
    sousuo:'search',
    dingdh:'OrderNum',
    xiadsj:'Order time',
    dingdxq:'Order details',
    dingdzf:'Order payment',
    jingruzx:'Entry Advisory',
    zxpj:'Consultation and evaluation',
    zczx:'Consultation again',
    zxls:'Consulting history',
    zjzxpj:'Expert consultation and evaluation',
    zjpj:'Additional evaluation',
    zxshic:'Consultation duration',
    xiaoshi:'hour',
    zjsp:'Expert level',
    huifzl:'Recovery quality',
    huifsd:'Recovery rate',
    pingjiasd:'Evaluation of drying list',
    fenxiangtiyan:'Share experience experience experience and give thousands of people who want to buy a reference',
    busaoyu:'Evaluation no less than 10 words',
    tijiaopj:'Submit evaluation',
    daipj:'To be evaluated',
    lijipingjia:'Immediate evaluation',
    liszx:'Historical consultation',
    ddpj:'Order evaluation',
    jianczl:'Testing quality',
    pinglfs:'Commentary score',
    shangctp:'Upload pictures',
    yiquxiao:'Cancelled'
}


// WEBPACK FOOTER //
// ./src/lang/member/ConsultationOrder/ConsultationOrderEn.js